module.exports = __webpack_public_path__ + "img/recipe.937c60f2.png";